<script setup lang="ts">
const props = defineProps<{
  title: StoryBlokHeading
  type: 'text' | 'small' | 'normal'
  items: {
    title: string
    text: StoryBlokRichText
    icon: StoryBlokIcon
  }[]
  injectedVariables?: KeyValuePair[]
}>()

const length = (() => `items-${props.items.length}`)()
const icon = (() => props.type === 'normal' ? { size: 60, msize: 40 } : { size: 40, msize: 24 })()

const injectedTitle = findTitleInArray(props.injectedVariables)
if (injectedTitle) props.title[0].text = injectedTitle
</script>

<template>
  <div>
    <StoryblokHeading class="sm:text-center" :title="title" />
    <div :class="[type, length]" class="flex justify-center mt-5">
      <div v-for="item in items" v-editable="item" class="item">
        <div v-if="type !== 'text'" class="item-icon">
          <AppIcon :size="icon.size" :msize="icon.msize" v-bind="item.icon" />
        </div>
        <div class="item-title">
          {{ item.title }}
        </div>
        <StoryblokRichText class="item-text" :document="item.text" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.normal {
  @apply flex-col gap-5 lg:gap-10 lg:flex-row;
  &.items-2 {
    @apply lg:max-w-900px;
  }
  .item {
    @apply flex items-center gap-4;
    &:not(:last-child) {
      @apply border-b-1 pb-5 pr-10 border-primary/45 lg:pb-0 lg:border-b-0 lg:border-r-1;
    }
    .item-title {
      @apply headline-1 whitespace-nowrap;
    }
    .item-icon {
      @apply text-primary;
    }
  }
}
.text {
  @apply flex-wrap lg:gap-5 lg:flex-nowrap;
  .item {
    @apply text-center basis-1/2 mb-9;
    .item-title {
      @apply font-semibold text-36px sm:text-huge text-primary mb-2.5 whitespace-nowrap;
    }
  }
}
.small {
  &.items-2 {
    @apply max-w-900px mx-auto gap-6 md:gap-5;
    .item {
      @apply flex content-start flex-wrap items-center gap-2.5 md:flex-nowrap;
      &:not(:last-child) {
        @apply pr-6 border-r-1 border-primary/45;
      }
      .item-icon {
        @apply text-primary;
      }
      .item-title {
        @apply headline-2 whitespace-nowrap;
      }
      .item-text {
        @apply text-center text-small basis-full md:text-left;
      }
    }
  }
  &.items-4 {
    @apply flex-col gap-5 lg:flex-row;
    .item {
      @apply flex gap-2.5 lg:flex-col lg:items-center;
      .item-icon {
        @apply text-primary mt-1 lg:mt-0;
      }
      .item-title {
        @apply headline-2 whitespace-nowrap;
      }
      .item-text {
        @apply text-large lg:px-5 lg:text-center;
      }
    }
  }
  .item {
    @apply mb-5 justify-center sm:mb-0 md:justify-start;
  }
}
</style>
